export const trackEvent = (event: string, properties?: Record<string, any>) => {
  if (typeof window !== 'undefined' && (window as any).analytics) {
    (window as any).analytics.track(event, properties);
  }
  // Fallback to console in development
  if (import.meta.env.DEV) {
    console.log('📊 Track Event:', event, properties);
  }
};


